import styles from "./result-set.module.scss";
import classNames from "classnames";
import useStore, { ResultSet as ResultSetType } from "../../store";

interface ResultSetProps {
  resultSet: ResultSetType;
}

const ResultSet = ({ resultSet }: ResultSetProps) => {
  const { setResultSetActive, eventId } = useStore();

  return (
    <div
      className={classNames(styles.resultSet, {
        [styles.activeResultSet]: resultSet.isActive,
      })}
      onClick={() => setResultSetActive(eventId, resultSet.id)}
    >
      {resultSet.name}
    </div>
  );
};

export default ResultSet;
